<template>
   <div>

      <h5>Extrato</h5>

      <p>Nossa nova tela de extrato. Depende da api para criarmos a tela.</p>

   </div>
</template>

<script>
export default {
   name: 'Extract',
}
</script>

<style scoped>

</style>
